const cartDrawer = document.querySelector('.cart-drawer');

const cartOverlay = document.querySelector('.cart-drawer-overlay');

const cartClose = document.querySelector('.cart-drawer-close');

const cartButton = document.querySelector('.lux-cart');

const cartContent = document.getElementById('cart-drawer-content');

const cartSubtotal = document.getElementById('cart-subtotal');

/* OPEN */

function openCartDrawer(){

  cartDrawer.classList.add('active');

  cartOverlay.classList.add('active');

}

/* CLOSE */

function closeCartDrawer(){

  cartDrawer.classList.remove('active');

  cartOverlay.classList.remove('active');

}

/* EVENTS */

cartClose.addEventListener(
  'click',
  closeCartDrawer
);

cartOverlay.addEventListener(
  'click',
  closeCartDrawer
);

cartButton.addEventListener(
  'click',
  openCartDrawer
);

/* FORMAT MONEY */

function formatMoney(cents){

  return '$' + (cents / 100).toFixed(2);

}

/* UPDATE HEADER COUNT */

function updateCartCount(count){

  let badge = document.querySelector(
    '.lux-cart-count'
  );

  if(count > 0){

    if(!badge){

      badge = document.createElement('span');

      badge.className = 'lux-cart-count';

      cartButton.appendChild(badge);

    }

    badge.innerText = count;

  }else{

    if(badge){

      badge.remove();

    }

  }

}

/* RENDER CART */

async function renderCart(){

  const response = await fetch('/cart.js');

  const cart = await response.json();

  cartContent.innerHTML = '';

  updateCartCount(cart.item_count);

  if(cart.item_count === 0){

    cartContent.innerHTML = `
      <p>
        Tu carrito está vacío.
      </p>
    `;

    cartSubtotal.innerHTML = '$0.00';

    return;

  }

  cart.items.forEach(item => {

    cartContent.innerHTML += `

      <div class="cart-drawer-item">

        <!-- IMAGE -->

        <div class="cart-drawer-item-image">

          <img
            src="${item.image}"
            alt="${item.product_title}"
          >

        </div>

        <!-- INFO -->

        <div class="cart-drawer-item-info">

        <h4 class="cart-drawer-item-title">

  ${item.product_title}

  <span class="cart-item-quantity">
    (${item.quantity})
  </span>

  ${
    item.variant_title &&
    item.variant_title !== 'Default Title'

    ?

    `
      <span class="cart-item-variant-inline">
        · ${item.variant_title}
      </span>
    `

    :

    ''
  }

</h4>

          <p class="cart-drawer-item-price">
            ${formatMoney(item.final_line_price)}
          </p>

          <!-- REMOVE -->

          <button
            class="cart-remove-btn"
            data-key="${item.key}"
          >

            Eliminar

          </button>

        </div>

      </div>

    `;

  });

  cartSubtotal.innerHTML = formatMoney(cart.total_price);

}

/* AJAX ADD TO CART */

document.addEventListener(
  'submit',
  async (event) => {

    const form = event.target;

    if(
      form.matches('form[action*="/cart/add"]')
    ){

      event.preventDefault();

      const formData = new FormData(form);

      await fetch(
        '/cart/add.js',
        {
          method:'POST',
          body:formData
        }
      );

      await renderCart();

      openCartDrawer();

    }

  }
);

/* REMOVE PRODUCT */

document.addEventListener(
  'click',
  async (event) => {

    const removeBtn = event.target.closest(
      '.cart-remove-btn'
    );

    if(removeBtn){

      const key = removeBtn.dataset.key;

      await fetch(
        '/cart/change.js',
        {
          method:'POST',

          headers:{
            'Content-Type':'application/json'
          },

          body:JSON.stringify({
            id:key,
            quantity:0
          })
        }
      );

      await renderCart();

    }

  }
);

/* INIT */

renderCart();